import './scss/index.scss';
import { dcFactory } from 'dc';
import AhBackButtonComponent from "./js/ah-back-button.component";

dcFactory.register(AhBackButtonComponent);
